/**
 * Microcopy keys
 *
 * Convention regarding microcopy key naming:
 * - Always use snakecase in uppercase: `MY_MICROCOPY_NAME`
 * - Name should start from the most generic attribute to the least.
 *   An example of this naming structure can be: `{PILLAR}_{COMPONENT}_{ATOM}`
 *   or `{PILLAR}_{PAGE}_{COMPONENT}_{ATOM}`
 * - In case your microcopy supports markdown or dynamic tokens,
 *   please add some documentation associated with your key
 */
import { accountMicrocopy } from './account';
import { authenticationMicrocopy } from './authentication';
import { bookingMicrocopy } from './booking';
import { carMatchMicrocopy } from './carMatch';
import { checkoutMicrocopy } from './checkout';
import { deliveryMicrocopy } from './delivery';
import { generalMicrocopy } from './general';
import { hygieneMicrocopy } from './hygiene';
import { magicMicrocopy } from './magic';
import { pdpMicrocopy } from './pdp';
import { personalizedQuotesMicrocopy } from './personalizedQuotes';
import { tradeInMicrocopy } from './tradeIn';

export type MicrocopyKey =
  | generalMicrocopy
  | accountMicrocopy
  | authenticationMicrocopy
  | carMatchMicrocopy
  | checkoutMicrocopy
  | deliveryMicrocopy
  | personalizedQuotesMicrocopy
  | pdpMicrocopy
  | tradeInMicrocopy
  | hygieneMicrocopy
  | magicMicrocopy
  | bookingMicrocopy;

export const MICROCOPY = {
  ...generalMicrocopy,
  ...accountMicrocopy,
  ...authenticationMicrocopy,
  ...carMatchMicrocopy,
  ...checkoutMicrocopy,
  ...deliveryMicrocopy,
  ...personalizedQuotesMicrocopy,
  ...pdpMicrocopy,
  ...tradeInMicrocopy,
  ...hygieneMicrocopy,
  ...magicMicrocopy,
  ...bookingMicrocopy,
};
